/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line import/prefer-default-export
export const updateMemberOrganization = (id: string, code: string, disable?: boolean) =>
  fetch(`/api/private-moneys/${id}/member-organizations/${code}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      disable,
      _csrf_token: (window as any)._csrf_token,
    }),
  });
